import React from "react";
import { Helmet } from "react-helmet-async";

const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",

    "@id": "https://bushireinpune.com/#travelagency",

    "name": "Amruta Travels",

    "url": "https://bushireinpune.com/",

    "logo": "https://bushireinpune.com/images/logo.jpg",

    "image": "https://bushireinpune.com/images/logo.jpg",

    "telephone": "+91 7353109555",

    "email": "booking@bushireinpune.com",

    "priceRange": "₹₹",

    "address": {
      "@type": "PostalAddress",
      "streetAddress":
        "Office No.-2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Vadgaon Budruk",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411041",
      "addressCountry": "IN"
    },

    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.4639,
      "longitude": 73.8312
    },

    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],

    "areaServed": [
      {
        "@type": "City",
        "name": "Pune"
      },
      {
        "@type": "State",
        "name": "Maharashtra"
      }
    ],

    "sameAs": [
      "YOUR_FACEBOOK_URL",
      "YOUR_INSTAGRAM_URL",
      "YOUR_GOOGLE_BUSINESS_PROFILE_URL"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;